(() => {
  // -----------------------------
  // Helpers
  // -----------------------------
  const getSheet = () => document.getElementById("gs-global-sheet");

  function isFooterArea(el) {
    // Burton desktop footer (if present)
    if (el.closest("#FooterBurtonFull, .burton-footer")) return true;

    // Real footer tag (some templates)
    if (el.closest("footer")) return true;

    // ✅ Shopify OS2.0 section wrappers:
    const wrapper = el.closest('[id^="shopify-section-"]');
    if (wrapper) {
      if (/__footer/i.test(wrapper.id)) return true;
      if (wrapper.classList.contains("shopify-section-group-footer-group")) return true;
    }

    return false;
  }

  /* THEME-UNIFY: Disabled sheet behavior - accordions are now always on-page.
     The modal "sheet" interaction has been disabled for cleaner flow. */
  function isMobileSheet() {
    return false; // Always use on-page accordions, never sheet
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle("gs-sheet-lock", lock);
    document.body.classList.toggle("gs-sheet-lock", lock);
  }

  function openSheet(title, html) {
    const sheet = getSheet();
    if (!sheet) return;

    const titleEl = sheet.querySelector("[data-gs-sheet-title]");
    const bodyEl = sheet.querySelector("[data-gs-sheet-body]");

    if (titleEl) titleEl.textContent = title || "";
    if (bodyEl) bodyEl.innerHTML = html || "";

    sheet.classList.add("is-open");
    sheet.setAttribute("aria-hidden", "false");
    lockScroll(true);
  }

  function closeSheet() {
    const sheet = getSheet();
    if (!sheet) return;

    sheet.classList.remove("is-open");
    sheet.setAttribute("aria-hidden", "true");
    lockScroll(false);
  }

  // -----------------------------
  // Close handlers (overlay + X + ESC)
  // -----------------------------
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-gs-sheet-close]")) {
      closeSheet();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeSheet();
  });

  // -----------------------------
  // Open handler (capture phase)
  // -----------------------------
  // Expose for external callers (e.g. trust badge buttons)
  window.gsOpenSheet = openSheet;

  document.addEventListener(
    "click",
    (e) => {
      const summary = e.target.closest("summary.details__header");
      if (!summary) return;

      // THEME-UNIFY: Sheet behavior only on mobile breakpoints
      if (!isMobileSheet()) return;

      // ✅ Footer accordions should behave normally (no modal sheet)
      if (isFooterArea(summary)) return;

      // Only hijack accordions rendered by your block
      const accordion = summary.closest("[data-gs-accordion]");
      if (!accordion) return;

      // If sheet is missing, don't hijack -> normal accordion behavior
      const sheet = getSheet();
      if (!sheet) return;

      // Hijack native <details>/<summary> toggle
      e.preventDefault();
      e.stopPropagation();

      const details = summary.closest("details.details");
      const content =
        details?.querySelector(".details-content") ||
        details?.querySelector("[data-gs-accordion-content]");

      const title =
        summary.querySelector("[data-gs-accordion-title]")?.textContent?.trim() ||
        summary.textContent.trim();

      const html = content ? content.innerHTML : "";

      // Make sure details isn't left open behind the sheet
      if (details) details.open = false;

      openSheet(title, html);
    },
    true
  );
})();
